import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config, secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
export function stripHtmlFromString(html) {
  const tempElement = document.createElement('div');
  tempElement.textContent = html;
  return tempElement.textContent || '';
}

/*
 * NOTE
 * Adds text at the start of a tag
 * Accepts string parameter with tags in it
 * Will add text before other text in the tag
 *
 * EXAMPLE
 * > addText('@', "Hey <span data-test>Name</span>! <span>Great function</span>", 'span', 'data-test')
 * Will return
 * > "Hey <span data-test>@Name</span> <span>Great function</span>"
 *
 * NOTE
 * span with out the identifingAttribute was not changed
 */
export function addText(newText, htmlString, identifyingTag, identifyingAttribute) {
  const div = document.createElement('div');
  const sanitizedHtmlString = sanitizeHtml(htmlString, [identifyingTag]);
  div.innerHTML = sanitizedHtmlString;
  const childElements = div.getElementsByTagName(identifyingTag);
  for (let index = 0; index < childElements.length; index++) {
    const element = childElements[index];
    if (element.hasAttribute(identifyingAttribute)) {
      const textNode = document.createTextNode(newText);
      element.insertBefore(textNode, element.firstChild);
    }
  }
  return div.innerHTML;
}
function replaceNbspAndAmp(string) {
  return string.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
}
export function sanitizeHtml(string, allowedTags) {
  const sanitizedText = sanitize(string, Object.assign({}, config.HTML, {
    elements: allowedTags,
    dom: secureDocument
  }));
  return replaceNbspAndAmp(sanitizedText);
}